import React from "react";
import DelReferee from "../../buttons/DelReferee";
import moment from "../../helpers/moment";

const TblReferee = ({ data }) => {
  return (
    <div className="row">
      {data?.map((v, i) => (
        <div className="col-md-6">
          <div className="card border  my-2" key={i} title={v.homeaddress}>
            <div className="card-body text-center">
              <div className="card-title text-uppercase pb-2 border-bottom">
                {v.firstname} {v.middlename} {v.lastname}
              </div>
              <div className="my-2">{v.phonenumber}</div>
              <div className="my-2 text-lowercase">{v.emailaddress}</div>
              <div className="my-2">{v.homeaddress}</div>
              <div className="my-2">{moment(v.createdAt)}</div>
              <div>
                {v.disabled ? (
                  <DelReferee modules={v} key={i} />
                ) : (
                  <button className="btn btn-icon btn-dark btn-rounded" disabled={true}>
                    <i className="ti-trash"></i>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TblReferee;
